export class FetchError extends Error {
  data: unknown;

  constructor(message: string, readonly status: number) {
    super(message);
    // Restores the prototype chain, which the ES5 class downlevel drops when
    // extending a built-in. Without this `instanceof FetchError` is always false.
    Object.setPrototypeOf(this, FetchError.prototype);
  }
}

export function isFetchError(error: unknown): error is FetchError {
  return error instanceof FetchError;
}

// Callers decide which statuses are a real answer about the resource. Matching
// a whole 4xx range is too broad: an auth, conflict or rate-limit response says
// nothing about whether the resource exists, and neither does a 5xx, a gateway
// timeout or a dropped connection.
export function isFetchErrorWithStatus(
  error: unknown,
  statuses: readonly number[]
): error is FetchError {
  return isFetchError(error) && statuses.includes(error.status);
}
